import script from "./CustomerDetailsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomerDetailsModal.vue?vue&type=script&setup=true&lang=ts"

import "./CustomerDetailsModal.vue?vue&type=style&index=0&id=5976ba27&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5976ba27"]])

export default __exports__